import React from "react";

const Contact = () => {
  return (
    <section className="section contact-section" id="contact">
      <div className="section-inner">
        <div className="contact-card reveal">
          <div className="eyebrow">Let's Connect</div>
          <h2 className="section-title">Let's build something great.</h2>
          <p>
            I'm actively looking for full-time software engineering roles.
            Let's chat about how I can contribute to your team.
          </p>
          <a href="mailto:developer@jaysmart.dev" className="btn btn-primary">
            developer@jaysmart.dev
          </a>
        </div>
      </div>
    </section>
  );
};

export default Contact;
